












































































import { Component } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import PageNames from '@/router/PageNames';
import { SysKBTOCListModule } from '@/store/modules/sysKBTOCList';

@Component({
  name: 'SysAdminTableOfContentsList',
  components: {
    Alert
  }
})
export default class extends GiganautVue {
  get loading() {
    return SysKBTOCListModule.loading;
  }

  get tocList() {
    return SysKBTOCListModule.tocList;
  }

  async mounted() {
    await this.loadTOCList();
  }

  async loadTOCList() {
    try {
      await SysKBTOCListModule.getTOCList();
    } catch (error) {
      console.error('Failed to load TOC list:', error);
    }
  }

  viewTOC(tocId: string) {
    this.$router.push({
      name: PageNames.SysAdminTableOfContents,
      params: { id: tocId }
    });
  }
}
